import { FC } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import TeamLineup from "../TeamLineup";
import { SportsVolleyball } from "@mui/icons-material";
import { useAppDataContext } from "@context/AppContext";
import { gameState, useTeamSides } from "@/services/gameState";
import TeamCoachName from "@components/TeamCoachName";

const RefereeTabletLineUp: FC = () => {
  const serving = gameState("serving");
  const appDataContext = useAppDataContext();
  const { leftTeam, rightTeam } = useTeamSides(appDataContext);
  const {
    usePlayerFirstNames,
    setUsePlayerFirstNames,
    setShowPlayerNames,
    showPlayerNames,
  } = appDataContext;
  const { palette } = useTheme();

  const toggleUsePlayerFirstNames = () =>
    setUsePlayerFirstNames(!usePlayerFirstNames);

  const toggleShowPlayerNames = () => setShowPlayerNames(!showPlayerNames);

  return (
    <Box
      pt={2}
      display={"grid"}
      gridTemplateColumns={`20fr 90fr 1fr 0 1fr 90fr 20fr`}
      gridTemplateRows={`2.5vw 1vw auto 1vw`}
      gridTemplateAreas={`
       "voidLeft             coachNameLeft  voidNetLeft     freeZoneTop      voidNetRight  coachNameRight            voidRight"
       "freeZoneTopLeft     freeZoneTopLeft     netLeft     freeZoneTop      netRight    freeZoneTopRight      freeZoneTopRight"
       "serviceLeft               left          netLeft        center        netRight        right                 serviceRight"
       "freeZoneBottomLeft  freeZoneBottomLeft  netLeft    freeZoneBottom    netRight  freeZoneBottomRight  freeZoneBottomRight"
      `}
      maxWidth={"100%"}
    >
      <Box
        sx={{ backgroundColor: palette.text.primary, gridArea: "netLeft" }}
      />
      <Box
        sx={{ backgroundColor: palette.text.primary, gridArea: "netRight" }}
      />
      <Box
        gridArea={"serviceLeft"}
        onClick={toggleShowPlayerNames}
        sx={{
          minWidth: "5vw",
          maxWidth: "10vw",
          transform: "scaleY(-1)",
        }}
      >
        <SportsVolleyball
          opacity={serving === leftTeam ? 1 : 0}
          sx={{ width: "100%", height: "auto", transition: "opacity 0.5s" }}
        />
      </Box>
      <Box
        gridArea={"serviceRight"}
        onClick={toggleUsePlayerFirstNames}
        sx={{ minWidth: "5vw", alignContent: "start", maxWidth: "10vw" }}
      >
        <SportsVolleyball
          opacity={serving === rightTeam ? 1 : 0}
          sx={{ width: "100%", height: "auto", transition: "opacity 0.5s" }}
        />
      </Box>
      <TeamLineup
        side={"left"}
        sx={{
          gridArea: "left",
          height: "100%",
        }}
        fontSize={"8vw"}
      />
      <TeamLineup
        side={"right"}
        sx={{
          gridArea: "right",
          height: "100%",
        }}
        fontSize={"8vw"}
      />
      <TeamCoachName
        side={"left"}
        sx={{ gridArea: "coachNameLeft" }}
        fontSize={"2.5vw"}
      />
      <TeamCoachName
        side={"right"}
        sx={{ gridArea: "coachNameRight" }}
        fontSize={"2.5vw"}
      />
    </Box>
  );
};

export default RefereeTabletLineUp;
